import React from 'react';
import PropTypes from 'prop-types';
import styles from './NewDocumentMenu.scss';
import estimateIcon from '../../../assets/estimate_icon.svg';
import invoiceIcon from '../../../assets/invoice_icon.svg';
import contractIcon from '../../../assets/contract_icon.svg';
import formIcon from '../../../assets/form_icon.svg';
import fileIcon from '../../../assets/file_icon.svg';
import workspaceIcon from '../../../assets/workspace_icon.svg';
import musicPlannerIcon from '../../../assets/music_planner_icon.svg';
import NewDocumentMenuItem from './NewDocumentMenuItem';

const NewDocumentMenu = ({ openNewDocumentModal, openNewWorkspaceModal, viewer }) => (
  <div>
    {/* <Dropdown
      className={className}
      text={text}
      floating
      labeled={labeled}
      icon={icon}
      button={button}
      basic={basic}
    >
      <Dropdown.Menu style={style}>
        <Dropdown.Item
          onClick={() => openNewDocumentModal('estimate')}
          text='Estimate'
        />
        <Dropdown.Item
          onClick={() => openNewDocumentModal('contract')}
          text='Contract'
        />
        <Dropdown.Item
          onClick={() => openNewDocumentModal('invoice')}
          text='Invoice'
        />
        <Dropdown.Item
          onClick={() => openNewDocumentModal('form')}
          text='Form'
        />
        <Dropdown.Item onClick={openNewWorkspaceModal} text='Workspace' />
        <Dropdown.Item
          onClick={() => openNewDocumentModal('file')}
          text='File Upload'
        />
      </Dropdown.Menu>
    </Dropdown> */}
    <div className={styles.menu}>
      <NewDocumentMenuItem
        icon={estimateIcon}
        title='Estimate'
        description='Send pricing information to clients'
        onClick={() => openNewDocumentModal('estimate')}
        color='blue'
        style={{ paddingTop: 0 }}
      />
      <NewDocumentMenuItem
        icon={contractIcon}
        title='Contract'
        description='Create an agreement that can be signed online'
        onClick={() => openNewDocumentModal('contract')}
        color='purple'
      />
      <NewDocumentMenuItem
        icon={invoiceIcon}
        title='Invoice'
        description='Set up a payment schedule and get paid'
        onClick={() => openNewDocumentModal('invoice')}
        color='lavender'
      />
      <NewDocumentMenuItem
        icon={formIcon}
        title='Form'
        description='Send customized questionnaires'
        onClick={() => openNewDocumentModal('form')}
        color='green'
      />
      {viewer.features.music_lists &&
        <NewDocumentMenuItem
          icon={musicPlannerIcon}
          title='Music List'
          description='Collect music requests for your event'
          onClick={() => openNewDocumentModal('music list')}
          color='peach'
        />}
      <NewDocumentMenuItem
        icon={fileIcon}
        title='File Upload'
        description='Upload files that can be shared'
        onClick={() => openNewDocumentModal('file')}
        color='orange'
      />
      <NewDocumentMenuItem
        icon={workspaceIcon}
        title='Workspace'
        description='Portal to collaborate with clients & team members'
        onClick={openNewWorkspaceModal}
        color='teal'
        style={{ paddingBottom: 0 }}
      />
    </div>
  </div>
);

NewDocumentMenu.propTypes = {
  openNewDocumentModal: PropTypes.func.isRequired,
  openNewWorkspaceModal: PropTypes.func.isRequired,
  viewer: PropTypes.object.isRequired
};

export default NewDocumentMenu;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/NewDocumentMenu.js